import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { usePageSettings } from "../contexts/PageSettingsContext";
import { useCheckout } from "../contexts/CheckoutPageContext";
import axios from "axios";

export const useFetchAddonPrice = ({ addonIds = [], paymentCycle = "monthly" }) => {
	const { currency } = usePageSettings();
	const { orderCount } = useCheckout();

	const fetchPriceWithAddons = async () => {
		if (!addonIds || addonIds.length === 0) return 0; // Return 0 if no addons

		const endpoint = `${process.env.GATSBY_PRICE_ENDPOINT}?currency=${currency}&cycle=${paymentCycle}&count=${orderCount}`;
		const payload = { addons: addonIds };

		try {
			const response = await axios.post(endpoint, payload, {
				headers: { "Content-Type": "application/json" },
			});
			return response.data.price;
		} catch (error) {
			throw new Error(`Failed to fetch addon price: ${error.message}`);
		}
	};

	return useQuery({
		queryKey: ["addonPrice", currency, addonIds, paymentCycle, orderCount], // Use memoized addonIds
		queryFn: fetchPriceWithAddons,
		refetchOnWindowFocus: false,
		enabled: addonIds.length > 0, // Only run query if there are addon IDs
	});
};
